<span id="{{Id}}">{{displayNum | number}}</span>
